"use client";

import React from "react";
import { BlurFade } from "@/components/ui/blur-fade";
import Link from "next/link";
import { ChevronRight } from "lucide-react";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsNavProps {
  items: BreadcrumbItem[];
}

const BreadcrumbsNav = ({ items }: BreadcrumbsNavProps) => {
  if (!items || items.length === 0) return null;

  return (
    <section className="py-4 px-6 bg-muted/30">
      <div className="container max-w-5xl mx-auto">
        <BlurFade delay={0.1}>
          <nav aria-label="Breadcrumb">
            <ol className="flex items-center flex-wrap gap-1 text-sm">
              {items.map((item, i) => {
                const isLast = i === items.length - 1;
                return (
                  <li key={i} className="flex items-center gap-1">
                    {i > 0 && (
                      <ChevronRight size={14} className="text-foreground/30 flex-shrink-0" />
                    )}
                    {isLast || !item.href ? (
                      <span className={`${isLast ? "text-foreground/70 font-medium" : "text-foreground/40"}`}>
                        {item.label}
                      </span>
                    ) : (
                      <Link
                        href={item.href}
                        className="text-foreground/40 hover:text-foreground/70 transition-colors"
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                );
              })}
            </ol>
          </nav>
        </BlurFade>
      </div>
    </section>
  );
};

export default BreadcrumbsNav;
